import { type StatusEnum } from 'enums/StatusEnum';
import { type FC, useMemo } from 'react';
import {
  getStatusReadableName,
  getStatusTailwindColor,
} from 'utils/statusUtil/statusUtil';

interface StatusChipPillProps {
  status: StatusEnum;
}

const StatusChipPill: FC<StatusChipPillProps> = ({ status }) => {
  const statusColor = useMemo(() => getStatusTailwindColor(status), [status]);
  return (
    <div
      className={`px-3 py-1 rounded-full flex items-center min-w-max ${statusColor}`}
    >
      <span className="uppercase text-xs font-semibold text-white">
        {getStatusReadableName(status)}
      </span>
    </div>
  );
};
export default StatusChipPill;
